<template>
  <div>
    <loader></loader>
  </div>
</template>

<script>
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import { projectBasePathWithFolder } from "../config/apiEndpoints";
import Loader from './Loader.vue';
import { keyMapsMutation } from '../helpers/storeKeys';
export default {
  name: "HomeTopBar",
  components: {
    Loader
    //
  },
  props: ["dataResults"],
  data() {
    return {
      pageContent: "",
    };
  },
  mounted() {
    if (!window.location.href.includes(Utility.getCurrentStoreFolder())) {
      this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true);
      window.location.href =
        projectBasePathWithFolder +
        Utility.getCurrentStoreFolder() +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
      return;
    }
  },
  methods: {
    //
  },
};
</script>
